import React from "react";
import styled from "styled-components";
// import Button from "../Button";
import Card from "react-bootstrap/Card";

import ios from "../../assets/images/ios.svg";
import { StyledDiv } from "./Section7.style";
import android from "../../assets/images/andriod.svg";
import Button from "react-bootstrap/Button";
import "../../assets/css/section.css";
const Container = styled.div`
  margin-bottom: 20px;
`;

const StyledCard = styled(Card)`
  margin-bottom: 20px;
  text-align: center;
  border-radius: 19px;
  padding: 20px;
  width: 10rem;
  align-items: center;
  border: 0px;
  height: 150px;
  background-color: #e6f8fc;
`;

const Image = styled.img`
  /* width: 100px;
  height: 100px; */
`;

const Section7 = () => {
  const handleAvailableonApp=()=>{
    window.open("")
  }
 const handleAndroid=()=>{
  window.open("https://apps.apple.com/us/app/myindici-2-0/id1577040594")
  }
 const handleDownloadIos=()=>{
  window.open("https://play.google.com/store/apps/details?id=nz.app.myindici")
  }
  return (
    <StyledDiv>
      <Container className="container text-center cta-available modrenHealth">
        <div className="row mt-5 mb-5  d-flex justify-content-center">
          <div className="col-md-8 mx-auto">
            <Button className="p-2 available-app"
            >Available on App</Button>
          </div>
        </div>
        <div className="row mb-5">
          <div className="col-md-12">
            <p className="benefitsmyindici">
              Download the myindici 2.0 app from Google Playstore or Apple App
              Store, depending on where you get your apps. With the myindici
              app, you can book appointments, request repeat prescriptions, send
              messages, view your health information and more, all from the
              comfort of your own phone.
            </p>
          </div>
        </div>
        <div className="row mb-md-5 avalblicons">
        <div className="col-md-12">
          <div className="row d-flex justify-content-center">  
            <div className="col-sm-6 col-md-3 mb-3 handleAndroid"  onClick={handleDownloadIos}>
              <StyledCard>
                <Card.Body>
                  <Image src={android} alt="images" className="text-center" />
                </Card.Body>
              </StyledCard>
              <span className="download-android">Download for Android</span>
            </div> 
            <div className="col-sm-6 col-md-3 mb-3 handleAndroid"  onClick={handleAndroid}
            > 
              <StyledCard>
                <Card.Body>
                  <Image src={ios} alt="images" />
                </Card.Body>
              </StyledCard>
              <span className="download-ios">Download for IOS</span>
            </div> 
          </div>
        </div>
      </div>
      </Container>
    </StyledDiv>
  );
};

export default Section7;
